"use client";
import { Button } from "@chakra-ui/react/button";

interface CategoryButtonProps {
  onClick?: () => void;
  category: string;
}

export const CategoryButton = ({ category, onClick }: CategoryButtonProps) => {
  return (
    <Button
      colorPalette="neutral"
      color="white"
      variant="solid"
      size="xs"
      onClick={onClick}
      _hover={{ bg: "none" }}
      py={2}
      fontWeight="light"
      fontFamily="heading"
    >
      {category}
    </Button>
  );
};
